export var createMuiFormControlOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        marginNormal: {
            marginTop: spacing(0),
            marginBottom: spacing(4),
        },
    });
};
//# sourceMappingURL=MuiFormControl.js.map